import { render } from "./search-filter-candidate-profiling.vue?vue&type=template&id=36596d81&scoped=true"
import script from "./search-filter-candidate-profiling.vue?vue&type=script&lang=js"
export * from "./search-filter-candidate-profiling.vue?vue&type=script&lang=js"

import "./search-filter-candidate-profiling.vue?vue&type=style&index=0&id=36596d81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36596d81"]])

export default __exports__